import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ApiService from "@/api/ApiService";
import { number } from '@amcharts/amcharts4/core';
Vue.use(VueAxios, axios)
export const EvohealthService = {
  baseURL: process.env.VUE_APP_EVOHEALTH_URL,

  getHealthParamsByGroup(healthGroupId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}v1/health-groups/${healthGroupId}/health-params`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  getHealthGroups() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}v1/health-groups`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  getHealthGroupsByIds(ids) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}v1/health-groups/by-ids?ids=${ids}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  getAnamneseDetails(id) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}v1/anamneses/${id}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  createAnamnese(data) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${this.baseURL}v1/anamneses`, data)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  deleteAnamnese(id) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.baseURL}v1/anamneses/${id}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  cloneAnamnese(data){
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}v1/anamneses/clone`, data)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  getAnamneses() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}v1/anamneses/permittable`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  sendReportEmail(leadId, healthGroups) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}v1/leads/${leadId}/sendreport?healthGroups=${healthGroups}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }

}


